var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZw = function SvgZw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M22.852 6.872a12.029 12.029 0 0 0-2.447-3.436l-8.404-.827-8.405.827-.08.08 3.357 3.356L12 7.03l10.851-.157ZM3.516 20.485c.044.044.088.089.133.132l8.351.775 8.351-.775a12.033 12.033 0 0 0 2.476-3.436l-15.523-.485-3.788 3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.88 10.308 9.914 9.913 12 12l-2.087 2.087 13.96-.343a12.086 12.086 0 0 0 .008-3.436Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 0a11.96 11.96 0 0 0-8.404 3.437h16.81A11.96 11.96 0 0 0 12 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.307 10.309H23.88a11.914 11.914 0 0 0-1.03-3.436H6.872l3.436 3.436ZM6.82 17.182h16.007c.511-1.068.87-2.223 1.046-3.436H10.255L6.82 17.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 24a11.96 11.96 0 0 0 8.35-3.383H3.649A11.96 11.96 0 0 0 12 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.285 2.81c-.267.224-.524.46-.77.705L12 12.001l-8.485 8.485c.246.246.503.481.77.705l9.19-9.19-9.19-9.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m4.825 8.87.777 2.39h2.514L6.082 12.74l.777 2.391-2.034-1.478L2.79 15.13l.777-2.391-2.034-1.479h2.515l.777-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.962 12.195-2.025-.718s-.15-1.403-.159-1.45a.783.783 0 1 0-1.523.353l-.567.571h1.009c0 1.048-.782 1.048-.782 2.091l.434 1.044h2.609l.434-1.043c.044-.1.07-.204.081-.307.375-.152.489-.541.489-.541Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgZw;